<p-dialog
  [header]="'User Profile Audit : ' + userName"
  [(visible)]="isShowUserProfileAuditModal"
  [draggable]="false"
  [style]="{ width: '100vw', height: '95vh' }"
  [modal]="true"
  (onHide)="closeUserProfileAuditModal()"
  id="userProfileAuditModal">
  <!-- need to render the audit trail and summary here -->
  <app-user-profile-audit-trail [auditTrailData]="auditTrailData"></app-user-profile-audit-trail>
</p-dialog>